export const breakpoints = [480, 768, 980, 1200]//ブレイクポイント
export const min = breakpoints.map(
  bp => `@media (min-width: ${bp}px)`
)
export const max = breakpoints.map(
    bp => `@media (max-width: ${bp}px)`
  )